import { render, staticRenderFns } from "./ArticleCardSkeleton.vue?vue&type=template&id=ed40f244&scoped=true"
import script from "./ArticleCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ArticleCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ArticleCardSkeleton.vue?vue&type=style&index=0&id=ed40f244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed40f244",
  null
  
)

export default component.exports